import angular from 'angular';
import salesComponent from './sales.component';
import SalesService from './sales.service';
import salesConfig from './sales.config';

let salesModule = angular.module('sales',[])
  .component('sales', salesComponent)
  .service('SalesService', SalesService)
  .config(salesConfig);

export default salesModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/catalog/sales/sales.js
 **/